/**
 * Imágenes para los avatares del listado (logo del contacto, foto del producto). El
 * listado no trae la imagen (es un data URI pesado): cada avatar pide la suya y los
 * pedidos de un mismo render se juntan en un POST /api/record-images por modelo. Queda
 * en memoria mientras dure la página; si el item cambió (otro updatedAt) se vuelve a
 * pedir.
 *
 * `images[model:id]`: undefined = no se pidió; null = no tiene; texto = el src.
 */
import Vue from "vue";
import { wencesApi } from "@/api/wencesApi";

const state = Vue.observable({ images: {} });
const versions = {};
let pending = {};
let timer = null;

async function flushModel(model, ids) {
  for (let i = 0; i < ids.length; i += 200) {
    const chunk = ids.slice(i, i + 200);
    try {
      const { data } = await wencesApi.post("/api/record-images", { model, ids: chunk });
      const images = (data && data.data && data.data.images) || {};
      chunk.forEach((id) => Vue.set(state.images, `${model}:${id}`, images[id] || null));
    } catch (e) {
      // Sin imagen quedan las iniciales; no se reintenta en esta página.
      chunk.forEach((id) => Vue.set(state.images, `${model}:${id}`, null));
    }
  }
}

function flush() {
  timer = null;
  const batch = pending;
  pending = {};
  Object.keys(batch).forEach((model) => flushModel(model, Array.from(batch[model])));
}

export function recordImage(model, id, version) {
  if (!model || !id) return null;
  const key = `${model}:${id}`;
  const v = String(version || "");
  if (state.images[key] === undefined || versions[key] !== v) {
    versions[key] = v;
    if (!(key in state.images)) Vue.set(state.images, key, undefined);
    (pending[model] = pending[model] || new Set()).add(String(id));
    if (!timer) timer = setTimeout(flush, 30);
  }
  return state.images[key] || null;
}
